/** Convert a wall-clock input in the configured monitor timezone, never the PC timezone. */
export function monitorTimeToUtc(value: string, timeZone: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value);
  if (!match) throw new Error("Укажите дату и время начала и окончания периода.");
  const [year, month, day, hour, minute, second] = match.slice(1).map((part) => Number(part ?? 0));
  const wall = Date.UTC(year, month - 1, day, hour, minute, second);
  const normalized = new Date(wall);
  if (normalized.getUTCFullYear() !== year || normalized.getUTCMonth() !== month - 1 || normalized.getUTCDate() !== day || hour > 23 || minute > 59 || second > 59) throw new Error("Некорректная дата периода.");
  const format = new Intl.DateTimeFormat("en-GB", { timeZone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" });
  const localEpoch = (instant: number) => {
    const p = Object.fromEntries(format.formatToParts(new Date(instant)).map((part) => [part.type, part.value]));
    return Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute), Number(p.second));
  };
  // Check both sides of a DST transition. Repeated times use the first occurrence;
  // nonexistent local times are rejected instead of silently moving the boundary.
  const offsets = new Set([-2, 0, 2].map((days) => { const instant = wall + days * 86_400_000; return localEpoch(instant) - instant; }));
  const candidates = [...offsets].map((offset) => wall - offset).filter((instant) => localEpoch(instant) === wall);
  if (!candidates.length) throw new Error(`Время ${value} не существует в часовом поясе ${timeZone}. Выберите другое время.`);
  return new Date(Math.min(...candidates)).toISOString();
}

export function p2pRangeQuery(period: string, from: string, to: string, timezone = "UTC", wholeDays = false) {
  if (period !== "custom") return `period=${encodeURIComponent(period)}`;
  if (!from || !to) throw new Error("Укажите обе границы периода.");
  if (wholeDays) {
    monitorTimeToUtc(`${to}T00:00:00`, timezone);
    const end = new Date(`${to}T00:00:00Z`);
    if (!Number.isFinite(end.getTime())) throw new Error("Некорректная дата окончания.");
    end.setUTCDate(end.getUTCDate() + 1);
    from += "T00:00:00";
    to = `${end.toISOString().slice(0, 10)}T00:00:00`;
  }
  const start = monitorTimeToUtc(from, timezone), end = monitorTimeToUtc(to, timezone);
  const duration = Date.parse(end) - Date.parse(start);
  if (duration <= 0 || duration > 366 * 86_400_000) throw new Error("Выберите даты по порядку, не более 366 дней.");
  return new URLSearchParams({ from: start, to: end }).toString();
}
